/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Employee } from './Employee';
import {
    EmployeeFromJSON,
    EmployeeFromJSONTyped,
    EmployeeToJSON,
    EmployeeToJSONTyped,
} from './Employee';

/**
 * 
 * @export
 * @interface ListEmployeesBelongingToUserResponse
 */
export interface ListEmployeesBelongingToUserResponse {
    /**
     * 
     * @type {Array<Employee>}
     * @memberof ListEmployeesBelongingToUserResponse
     */
    data: Array<Employee>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeesBelongingToUserResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeesBelongingToUserResponse interface.
 */
export function instanceOfListEmployeesBelongingToUserResponse(value: object): value is ListEmployeesBelongingToUserResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeesBelongingToUserResponseFromJSON(json: any): ListEmployeesBelongingToUserResponse {
    return ListEmployeesBelongingToUserResponseFromJSONTyped(json, false);
}

export function ListEmployeesBelongingToUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeesBelongingToUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeesBelongingToUserResponseToJSON(json: any): ListEmployeesBelongingToUserResponse {
      return ListEmployeesBelongingToUserResponseToJSONTyped(json, false);
  }

  export function ListEmployeesBelongingToUserResponseToJSONTyped(value?: ListEmployeesBelongingToUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

